// src/pages/FormationPages/SécuritéAlimentaire.js
import React, { useState } from 'react';
import './securitéalimentaire.css'; // Import the CSS file
import Header from '../../components/Header'; // Import the Header component
import Footer from '../../components/Footer'; // Import the Footer component
import { useNavigate } from 'react-router-dom';

// Sample data for the trainings
const trainings = [
    {
        id: 'sustainable-practices',
        title: 'Exigences de la Norme ISO 22000:2018',
        details: [
            { detail: "Description", description: "Découvrez comment développer un système de management de la sécurité des denrées alimentaires efficace et efficient conforme à la norme ISO 22000:2018." },
            { detail: "Objectives", description: (
                <p>
                    • Se familiariser avec les concepts et principes fondamentaux de la norme ISO 22000<br/>
                    • Comprendre les exigences de la norme ISO 22000:2018 et être en mesure de les appliquer aux processus de son entreprise<br/>
                    • Connaitre les méthodes et les outils nécessaires pour la mise en place d’un système de management de la sécurité des denrées alimentaires
                </p>
            )}
        ]
    },
    {
        id: 'corporate-social-responsibility',
        title: 'Auditeur interne ISO 22000:2018',
        details: [
            { detail: "Description", description: "La norme ISO 22000 positionne l’audit interne comme un outil de management incontournable pour la vérification de l’efficacité des systèmes de management de la santé et de la sécurité au travail." },
            { detail: "Objectives", description: (
                <p>
                    • Acquérir la qualification « auditeur interne ISO 22000:2018 »<br/>
                    • Maitriser les techniques d’audit et de communication en situation d’audit<br/>
                    • Etre capable de réaliser des audits internes à haute valeur ajoutée<br/>
                    • Savoir rédiger un rapport d’audit basé sur l’amélioration
                </p>
            )}
        ]
    },
    {
        id: 'fssc-22000-v6',
        title: 'Exigences de la Norme FSSC 22000 V6',
        details: [
            { detail: "Description", description: "La certification d’un système de management de la sécurité des denrées alimentaires selon la norme FSSC 22000 démontre un engagement envers la sécurité des aliments, la qualité, la légalité et l'amélioration continue." },
            { detail: "Objectives", description: (
                <p>
                    • Situer la norme FSSC 22000 dans le contexte normatif et règlementaire<br/>
                    • Comprendre la structure et les exigences de la norme FSSC 22000 v6 et mettre en place un système de management conforme<br/>
                    • Mise en évidence des modifications : version 6 vs version 5.1
                </p>
            )}
        ]
    },
    {
        id: 'haccp-method',
        title: 'Méthode HACCP : Garantir la sécurité des aliments',
        details: [
            { detail: "Description", description: "La méthode HACCP a été créée dans le but de garantir la sécurité des aliments. Elle prévoit l'analyse des dangers à chaque étape de la production en vue de leur maîtrise." },
            { detail: "Objectives", description: (
                <p>
                    • Positionner la démarche HACCP dans le cadre d’un système de management de la sécurité des denrées alimentaires<br/>
                    • Assimiler les principes et les étapes de la méthode HACCP<br/>
                    • Être en mesure de réaliser l’analyse des dangers liés à la sécurité alimentaire et d’adopter les mesures et les bonnes pratiques d'hygiène
                </p>
            )}
        ]
    }
];

const SécuritéAlimentaire = () => {
    const [selectedTraining, setSelectedTraining] = useState(null);
    const navigate = useNavigate();

    // Function to handle detail view
    const handleDetailsView = (training) => {
        setSelectedTraining(training);
    };

    // Function to go back to the catalog
    const handleBackToCatalog = () => {
        setSelectedTraining(null);
    };

    // Render the catalog view
    const renderCatalog = () => (
        <div className="training-catalog">
            <h1 className="catalog-title">Formation - Sécurité Alimentaire</h1>
            <div className="training-list">
                {trainings.map((training) => (
                    <div key={training.id} className="card-centered shadow">
                        <h3 className="card-title">{training.title}</h3>
                        <p className="card-description">{training.description}</p>
                        <button onClick={() => handleDetailsView(training)} className="btn btn-primary">
                            En savoir plus
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );

    // Render the details view
    const renderDetails = () => (
        <div className="container mt-5">
            <button className="btn btn-secondary mb-4" onClick={handleBackToCatalog}>
                Retour au Catalogue
            </button>
            <table className="details-table">
                <thead>
                    <tr>
                        <th colSpan="2" className="details-title">{selectedTraining.title}</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedTraining.details.map((detail, index) => (
                        <tr key={index}>
                            <td>{detail.detail}</td>
                            <td>{detail.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Participer button */}
            <div className="text-center mt-4">
                <button
                    className="btn btn-success"
                    onClick={() => navigate('/contact', { state: { training: selectedTraining.title } })}
                >
                    Participer
                </button>
            </div>
        </div>
    );

    return (
        <div className="min-vh-100">
            <Header />
            <div className="catalog-spacing" />
            {selectedTraining ? renderDetails() : renderCatalog()}
            <Footer />
        </div>
    );
};

export default SécuritéAlimentaire;